import type { AxiosResponse } from "axios";

import { validateValues } from "../../utils";
import api from "../../../../../api";
import type { IUser } from "../../../../../types";
import { CommandFormValues } from "../../types";
import { resetUserTaxCaseSchema } from "./types";

export const handleResetUserTaxCase = async (
  user: IUser,
  values: CommandFormValues
): Promise<AxiosResponse> => {
  const { date } = validateValues(values, resetUserTaxCaseSchema);

  return await api.kontax.resetUserTaxCase(user.id, date);
};
